import styled from 'styled-components';
import { ThemeColors } from '../theme';

const Sizes = {
  M: { fontSize: 4, textShadow: 0.5, stroke: 0.25 },
  L: { fontSize: 8, textShadow: 1, stroke: 0.5 },
};

export const Status = styled.div<{ $color: ThemeColors; $size: 'M' | 'L' }>`
  font-size: ${(props) =>
    `${Sizes[props.$size].fontSize.toString()}${props.theme.unit}`};
  text-shadow: 0
    ${(props) =>
      `${Sizes[props.$size].textShadow.toString()}${props.theme.unit}`}
    0 #000;
  -webkit-text-stroke: ${(props) =>
      `${Sizes[props.$size].stroke.toString()}${props.theme.unit}`}
    #000;
  color: ${(props) => props.theme.color[props.$color]};
`;
